import { render, staticRenderFns } from "./B-3-2-8__BUPageEdit_Sec-Quicktips.vue?vue&type=template&id=6a5e2a00&"
import script from "./B-3-2-8__BUPageEdit_Sec-Quicktips.vue?vue&type=script&lang=js&"
export * from "./B-3-2-8__BUPageEdit_Sec-Quicktips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
